import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import { MdOutlineEdit } from "react-icons/md";

import { IoAdd } from "react-icons/io5";
import BaseUrl from "../../Components/BaseUrl";
import Cookies from "js-cookie";
import { Link } from "react-router-dom";
import swal from "sweetalert2";
const EditEducation = () => {
  const [educationdata, setEducationdata] = useState([]);
  const [isEducationOpen, setIsEducationopen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [checkedSkills, setCheckedSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [skills, setSkills] = useState([]);
  const skillsRef = useRef([]);
  const [filteredSkills, setFilteredSkills] = useState([skillsRef.current]);
  const [educationformData, setEducationFormData] = useState({
    school: "",
    degree: "",
    field_of_study: "",
    start_month: "",
    start_year: "",
    end_month: "",
    end_year: "",
    grade: "",
    activities: "",
    description: "",
    skills: [],
    media: [],
  });

  const [educationError, setEducationError] = useState({});

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const years = Array.from(
    { length: new Date().getFullYear() - 1950 + 1 },
    (_, i) => 1950 + i
  ).reverse();
  const dates = Array.from({ length: 31 }, (_, i) => i + 1);
  const educationopenModal = () => {
    setIsEducationopen(true);
  };
  const educationcloseModal = () => {
    setIsEducationopen(false);
  };
  const oneducationformDataChange = (e) => {
    const { name, value } = e.target;
    setEducationFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setEducationError((prevData) => ({ ...prevData, [name]: "" }));
  };
  const openaddskillmodal = () => {
    setCheckedSkills([...selectedSkills]);
    setShowModal(true);
  };
  const saveexperienceSkills = () => {
    setExperienceFormData((prev) => ({
      ...prev,
      skills: checkedSkills,
    }));
    setShowModal(false);
  };
  const handleCheckboxChange = (skill) => {
    setCheckedSkills((prev) =>
      prev.includes(skill) ? prev.filter((s) => s !== skill) : [...prev, skill]
    );
  };
  const getProfileData = async (id) => {
    try {
      const response = await axios.get(BaseUrl + `users`,{
        headers: {
          Authorization: `Bearer ${Cookies.get("token")}`,
          Accept: "application/json",
        },
      });
      const response2 = await axios.get(BaseUrl + "skills");
      setEducationdata(response.data.data.education);
      skillsRef.current = response2.data;
      setSkills(response2.data);
      setFilteredSkills(response2.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    const id = Cookies.get("userId");
    console.log(id);
    getProfileData(id);
  }, []);

  const validateeducationForm = () => {
    let result = true;
    let errors = {};
    if (educationformData.school === "") {
      errors.school = "Please enter your school";
      result = false;
    }
    if (educationformData.degree === "") {
      errors.degree = "Please enter your degree";
      result = false;
    }
    setEducationError(errors);
    return result;
  };
  const handleeducationformsubmit = async (e, id) => {
    e.preventDefault();
    const result = validateeducationForm();
    if (result) {
        const response = await axios.post(
        BaseUrl + `users/editEducation/${id}`,
        educationformData,{
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
            Accept: "application/json",
        }}
      );
      if (response.status === 200) {
        setIsEducationopen(false);
        setEducationFormData("");
        getProfileData(Cookies.get("userId"));
      }
    }
  };
  const handledeleteeducation = async (e, id) => {
    const result = swal.fire({
      title: "Are you sure?",
      text: "You want to delete this experience?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    });
    if (result.isConfirmed) {
      try {
        const response = await axios.post(
          BaseUrl + `users/deleteEducation/${id}`
        );
        if (response.status === 200) {
          setIsEducationopen(false);
          getProfileData(Cookies.get("userId"));
          swal.fire("Deleted!", "Your experience has been deleted.", "success");
        }
      } catch (error) {
        console.log(error);
        swal.fire("Error!", "Something went wrong. Please try again.", "error");
      }
    }
  };
  return (
    <div className="bg-[#F3F2EF] mt-14  ">
      <div className="container mx-auto flex flex-col lg:flex-row py-8 gap-4 px-4 sm:px-6 lg:px-8">
        <div className="w-full lg:w-3/4 ">
          <div className="flex flex-col  bg-white w-full border border-gray-300 rounded-md  py-4">
            <div className="flex  justify-between items-center px-4">
              <div className="flex space-x-8 ">
                <div className="text-2xl">
                  <Link to={"/user/userprofile"}>
                    <FaArrowLeftLong />
                  </Link>
                </div>
                <div>
                  <p className="text-xl">Education</p>
                </div>
              </div>
              {/* <div className="text-3xl text-gray-500 hover:text-black hover:bg-gray-200 rounded-full p-1">
                <IoAdd />
              </div> */}
            </div>
            <div className="mt-4">
              {educationdata.map((education, index) => (
                <div className="flex justify-between items-center bg-white  my-4 px-4 border-b border-gray-200">
                  <div className="flex space-x-4">
                    <img
                      src="https://placehold.co/50x50"
                      alt="Company logo"
                      className="w-12 h-12 object-cover rounded-full"
                    />
                    <div>
                      <h3 className="text-lg font-semibold">
                        {education.school}
                      </h3>
                      <p className="text-gray-600">
                        {education.degree}, {education.field_of_study}
                      </p>
                      <p className="text-gray-600">
                        {education.start_year} - {education.end_year}
                      </p>
                    </div>
                  </div>
                  <div>
                    <button
                      className="text-2xl text-gray-500 hover:text-black hover:bg-gray-200 rounded-full p-2"
                      onClick={() => {
                        if (educationdata && education) {
                          educationopenModal();
                          setEducationFormData(education);
                        } else {
                          console.error("Invalid experience data:");
                        }
                      }}
                    >
                      <MdOutlineEdit />
                    </button>
                  </div>
                  {isEducationOpen && (
                    <div className="fixed inset-0 bg-gray-800 bg-opacity-10 flex items-center justify-center z-50 ">
                      <div className="bg-white shadow-lg rounded-[30px] w-full max-w-2xl mx-auto border-8 border-gray-500 ">
                        <div className="flex justify-between items-center bg-gray-200 p-5 rounded-t-[30px] ">
                          <h2 className="text-xl font-semibold">
                            Edit Education
                          </h2>
                          <button
                            onClick={educationcloseModal}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <i className="fas fa-times"></i>
                          </button>
                        </div>
                        <div className="">
                          <div className="overflow-y-auto max-h-[500px]">
                            <div className="flex  justify-between bg-blue-100 px-8 py-4">
                              <div class="flex flex-col items-start mb-2">
                                <h2 class="text-lg font-semibold">
                                  Notify network
                                </h2>
                                <p className="text-sm text-black w-96">
                                  Turn on to notify your network of key profile
                                  changes (such as new education) and work
                                  anniversaries. Updates can take up to 2 hours.
                                  Learn more about{" "}
                                  <a href="#" className="text-blue-600">
                                    sharing profile changes
                                  </a>
                                  .
                                </p>
                              </div>
                              <div className="">
                                <span className="text-gray-800 mr-2">On</span>
                                <label className="switch">
                                  <input type="checkbox" />
                                  <span className="slider round"></span>
                                </label>
                              </div>
                            </div>
                            <form>
                              <div className="py-4 px-8 ">
                                <p className="text-red-500 text-sm mb-6">
                                  * Indicates required
                                </p>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    School{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="school"
                                    value={educationformData.school}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Boston University"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500">
                                    {educationError.school}
                                  </span>
                                </div>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Degree
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <input
                                    id="degree"
                                    name="degree"
                                    value={educationformData.degree}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Bachelor's"
                                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                  />
                                  <span className="text-red-500">
                                    {educationError.degree}
                                  </span>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="industry"
                                  >
                                    Field of Study
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="field_of_study"
                                    value={educationformData.field_of_study}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder="Ex: Business"
                                  />
                                </div>

                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    Start Date
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      name="start_month"
                                      value={educationformData.start_month}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      name="start_year"
                                      value={educationformData.start_year}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label className="block text-gray-700 text-sm font-bold mb-2">
                                    End Date
                                  </label>
                                  <div className="grid grid-cols-2 gap-4">
                                    <select
                                      name="end_month"
                                      value={educationformData.end_month}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Month</option>
                                      {months.map((month, index) => (
                                        <option key={index} value={month}>
                                          {month}
                                        </option>
                                      ))}
                                    </select>
                                    <select
                                      name="end_year"
                                      value={educationformData.end_year}
                                      onChange={oneducationformDataChange}
                                      className="border-b-2 border-gray-400 p-2 w-full bg-transparent focus:outline-none focus:border-black"
                                    >
                                      <option value="">Year</option>
                                      {years.map((year) => (
                                        <option key={year} value={year}>
                                          {year}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="grade"
                                  >
                                    Grade
                                  </label>
                                  <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="grade"
                                    value={educationformData.grade}
                                    onChange={oneducationformDataChange}
                                    type="text"
                                    placeholder=""
                                  />
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="activities and societies"
                                  >
                                    Activities and Societies
                                  </label>
                                  <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="activities"
                                    value={educationformData.activities}
                                    onChange={oneducationformDataChange}
                                    rows="4"
                                    placeholder="Ex: Alpha Phi Omega, Marching Band, Volleyball"
                                  ></textarea>
                                </div>
                                <div className="mb-6">
                                  <label
                                    className="block text-gray-700 text-sm font-bold mb-2"
                                    htmlFor="description"
                                  >
                                    Description
                                  </label>
                                  <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                    name="description"
                                    value={educationformData.description}
                                    onChange={oneducationformDataChange}
                                    rows="4"
                                  ></textarea>
                                </div>

                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Skills
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    We recommend adding your top 5 used in this
                                    experience. They'll also appear in your
                                    Skills section.
                                  </p>
                                  <div className="flex flex-wrap gap-2 mb-3">
                                    {educationformData.skills?.map(
                                      (skill, index) => (
                                        <span
                                          key={index}
                                          className="bg-gray-200 px-3 py-1 rounded-full text-gray-700"
                                        >
                                          {skill}
                                        </span>
                                      )
                                    )}
                                  </div>
                                  <button
                                    className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      openaddskillmodal();
                                    }}
                                  >
                                    <i className="fas fa-plus mr-2"></i> Add
                                    Skill
                                  </button>
                                  {showModal && (
                                    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
                                      <div className="bg-white p-5 rounded-lg shadow-lg w-80">
                                        <h3 className="text-lg font-semibold mb-3">
                                          Select Skills
                                        </h3>
                                        <div className="max-h-40 overflow-y-auto">
                                          {skills?.map((skill, index) => (
                                            <label
                                              key={index}
                                              className="flex items-center space-x-2 mb-2"
                                            >
                                              <input
                                                type="checkbox"
                                                checked={checkedSkills.includes(
                                                  skill.skill_name
                                                )}
                                                onChange={() =>
                                                  handleCheckboxChange(
                                                    skill.skill_name
                                                  )
                                                }
                                              />
                                              <span>{skill.skill_name}</span>
                                            </label>
                                          ))}
                                        </div>

                                        <div className="flex justify-end mt-4">
                                          <button
                                            onClick={() => setShowModal(false)}
                                            className="mr-3 px-4 py-2 border border-gray-300 rounded"
                                          >
                                            Cancel
                                          </button>
                                          <button
                                            onClick={saveeducationSkills}
                                            className="px-4 py-2 bg-blue-500 text-white rounded"
                                          >
                                            Save
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div className="mb-6">
                                  <h2 className="text-lg font-semibold text-gray-700">
                                    Media
                                  </h2>
                                  <p className="text-[10px] text-gray-500 mb-2">
                                    Add media like images, documents, sites or
                                    presentations. Learn more about{" "}
                                    <a href="#" className="text-blue-500">
                                      media file types supported
                                    </a>
                                  </p>
                                  <button className="flex items-center text-blue-500 border border-blue-500 rounded-full px-4 py-2">
                                    <i className="fas fa-plus mr-2"></i> Add
                                    media
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="flex justify-between border-t-[1px] border-gray-200 py-4 px-8 ">
                          <button
                            type="submit"
                            className="bg-white text-gray-700 hover:bg-gray-100 px-6 py-2 rounded-lg"
                            onClick={(e) =>
                              handledeleteeducation(e, educationformData.id)
                            }
                          >
                            Delete Education
                          </button>
                          <button
                            type="submit"
                            className="bg-blue-600 text-white px-6 py-2 rounded-lg"
                            onClick={(e) =>
                              handleeducationformsubmit(
                                e,
                                educationformData.id
                              )
                            }
                          >
                            Save
                          </button>
                        </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/4">
          <div className="bg-white w-full border border-gray-300 rounded-md">
            <img
              src="https://placehold.co/200x200"
              alt="Profile picture"
              className="w-full h-48 object-cover rounded-t-md"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditEducation;
